<template>
  <div id="farmerspace-content">
    <v-container grid-list-xl v-if="contents.length > 0">
      <v-layout justify-center :key="index" row v-for="(content, index) in contents" wrap>
        <!-- Content Header  -->
        <v-flex md8 sm10 xs12>
          <span class="display-3 font-weight-bold head-page hidden-sm-and-down">
            {{ content.post_title }}
          </span>
          <span class="display-1 font-weight-bold head-page hidden-md-and-up">
            {{ content.post_title }}
          </span>
          <div class="caption mt-2 purple--text text--darken-2">
            {{ $moment(content.post_date).format('MMMM Do, YYYY') }}
          </div>
        </v-flex>

        <v-flex class="font-THSarabunNew" md6 pb-0 sm10 xs12>
          <!-- product detail -->
          <div class="card-product" v-if="products.length">
            <v-img
              :aspect-ratio="4 / 3"
              class="grey lighten-2 mb-4"
              :lazy-src="randomOtherPicture"
              :src="randomOtherPicture"
              v-if="randomOtherPicture"
            >
              <v-layout align-center fill-height justify-center ma-0 slot="placeholder">
                <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
              </v-layout>
            </v-img>
            <span class="font-weight-bold">{{ products.productname }}</span>
            <span class="font-weight-bold">
              {{ products.productnameeng ? ` (${products.productnameeng})` : '' }}
            </span>
            {{ products.scientificname ? `ชื่อวิทยาศาสตร์ ${products.scientificname}` : '' }}
            {{ products.typename ? `เป็น${products.typename}` : '' }}
            {{ products.productdescription || '' }}
          </div>

          <!-- variety of product -->
          <div class="my-4 card-varietyOfProduct text-xs-center" v-if="varietyOfProduct.length > 0">
            <span class="mr-2">{{ `สายพันธุ์${products.productname} :` }}</span>
            <v-chip
              class="font-weight-bold"
              color="purple darken-2"
              :key="index"
              small
              style="font-size:0.8em!important;letter-spacing:2px;"
              text-color="white"
              v-for="(variety, index) in varietyOfProduct"
              >{{ variety.varietyname }}</v-chip
            >
          </div>

          <!-- variety detail -->
          <div class="my-2 card-variety" v-if="varietys.length">
            <span class="font-weight-bold">
              {{ `${products.productname}${varietys.varietyname}` }}
            </span>
            <span class="font-weight-bold">
              {{ varietys.varietynameeng ? ` (${varietys.varietynameeng})` : '' }}
            </span>
            {{ varietys.varietydescription || '' }}
          </div>

          <!-- Content -->
          <div id="post-content"></div>

          <!-- Contact -->
          <p>
            {{
              `ซึ่งหากตอนนี้คุณเป็นเกษตรกรที่กำลังทำฟาร์ม${products.productname || ''}
            แล้วสนใจที่จะหาช่องทางการขายใหม่ๆ หรือเป็นธุรกิจที่กำลังอยากหาซื้อ${products.productname ||
              ''}
            ไม่ว่าจะเป็น ${products.allPartsName || ''}
            สามารถใช้บริการให้คำปรึกษาได้ตามลิงค์ต่อไปนี้
            `
            }}
            <router-link :to="{ name: 'contentRegister' }">เพียงคลิกที่ข้อความนี้</router-link>
            {{ `หรือ โทร ${adminPhone}` }}
          </p>
        </v-flex>

        <!-- Ads Desktop -->
        <v-flex class="hidden-sm-and-down" md2 pb-0 text-xs-center>
          <img
            alt
            class="sticky"
            height="280"
            :src="require('../assets/ads/336x280.png')"
            width="336"
          />
          <!-- <div class="sticky">I will stick to the screen when you reach my scroll position</div> -->
        </v-flex>

        <!-- Search Box -->
        <v-flex md8 pt-0 sm10 text-xs-center xs12>
          <base-content-search-box></base-content-search-box>
        </v-flex>

        <!-- Ads -->
        <v-flex md8 px-0 sm10 text-xs-center xs12>
          <img alt height="90" :src="require('../assets/ads/728x90.png')" width="728" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl v-else>
      <v-layout align-center justify-center row style="height:100vh" wrap>
        <v-flex text-xs-center xs12>
          <v-progress-circular color="primary" indeterminate :size="50"></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'farmerspace-content',
  data() {
    return {
      contents: [],
      products: [],
      varietys: [],
      varietyOfProduct: [],
      randomOtherPicture: ''
    }
  },
  computed: {
    adminPhone() {
      return this.$store.getters['Admin/getAll']
    }
  },
  async created() {
    this.$store.dispatch('Admin/fetch')
  },
  async mounted() {
    await this.getContent()
    // format post content
    var txt = this.contents[0].post_content
    var dataArr = txt.split('\n')
    var tempOl = ''
    dataArr.forEach(element => {
      if (element.search('<ol>') != -1 || element.search('<ul>') != -1) {
        tempOl += element
      } else if (element.search('<li>') != -1) {
        tempOl += element
      } else if (element.search('</ol>') != -1 || element.search('</ul>') != -1) {
        tempOl += element
        document.getElementById('post-content').innerHTML += tempOl
        tempOl = ''
      } else {
        document.getElementById('post-content').innerHTML += ' <p>' + element + '</p>'
      }
    })
    await this.getProductDetail()
    this.getVarietyDetail()
    this.getVarietyOfProduct()
    this.getOtherPicture()
  },
  methods: {
    async getContent() {
      try {
        const response = await this.axios.get(`farmerspace/content/${this.$route.params.postId}`)
        this.contents = response.data
      } catch (error) {
        throw new Error(error)
      }
    },
    async getProductDetail() {
      try {
        const response = await this.axios.get(
          `portal/content/productDetail/${this.$route.params.postId}`
        )
        response.data.length ? (this.products = response.data[0]) : ''
      } catch (error) {
        throw new Error(error)
      }
    },
    async getVarietyDetail() {
      try {
        const response = await this.axios.get(
          `portal/content/varietyDetail/${this.$route.params.postId}`
        )
        response.data.length ? (this.varietys = response.data[0]) : ''
      } catch (error) {
        throw new Error(error)
      }
    },

    async getVarietyOfProduct() {
      try {
        if (this.products) {
          const response = await this.axios.get(
            `portal/content/varietyOfProduct/${this.products.productid}`
          )
          this.varietyOfProduct = response.data
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async getOtherPicture() {
      try {
        if (this.products) {
          if (this.products.varietyId) {
            const response = await this.axios.get(
              `portal/content/otherPicture/variety/${this.products.varietyId}`
            )
            this.randomOtherPicture = this.doRandomPicture(response.data)
          } else if (this.products.productId) {
            const response = await this.axios.get(
              `portal/content/otherPicture/product/${this.products.productId}`
            )
            this.randomOtherPicture = this.doRandomPicture(response.data)
          }
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    doRandomPicture(image) {
      var randomNumber = Math.floor(Math.random() * image.length)
      return image.length > 0 ? image[randomNumber].otherpictures : null
    }
  }
}
</script>

<style lang="scss">
#farmerspace-content {
  font-size: 18px;
  img {
    max-width: 100%;
    height: auto;
    width: 100%;
    vertical-align: middle;
    &.aligncenter {
      clear: both;
      margin-bottom: 1.6em;
    }
  }
  p {
    margin: 0 0 0.8em;
    font-weight: 300;
  }
  strong {
    font-weight: 700;
  }
  ol {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 1em;
    font-size: 20px;
  }
  .font-THSarabunNew {
    font-family: 'THSarabunNew' !important;
    font-size: 1.2em;
    line-height: 1.3em;
  }
  .card-varietyOfProduct {
    background-color: #eceff1;
    padding: 10px 20px;
    border-radius: 12px;
  }
}
</style>
